import { handleRequestGet } from '../axios';
import { parseResult, queryParamStr, queryParamStrArr } from './GeneralFunc';
import {logMessage} from '../../components/utils.js';
import { generateEcdhKeys } from '../../crypto/ecdhCrypto';
import { gcmDecrypt } from '../../crypto/msgCrypto';
import Config from '../../config';

export const getTncDetail = async () => {
    let url = '/broadcast/tnc?';
    let queryString = '';
    // queryString += queryParamStr('year', year, true);
    let fullUrl = url + queryString;
    let result = await handleRequestGet(fullUrl, {});
    logMessage('getTncDetail', result);
    return parseResult(result).tnc || null;
};

export const getResearchList = async ({
    size = 10,
    page = 1,
    category = null,
    dateStart = null,
    dateEnd = null,
    term = null,
    exchanges = null,
    stocks = null
}) => {
    let url = '/broadcast/research?';
    let queryString = '';
    queryString += queryParamStr('size', size, true);
    queryString += queryParamStr('page', page);
    queryString += queryParamStr('category', category);
    queryString += queryParamStr('term', term);
    queryString += queryParamStrArr('exchanges[]', exchanges);
    queryString += queryParamStrArr('stocks[]', stocks);

    if (dateStart && dateEnd) {
        queryString += queryParamStr('range[start]', dateStart);
        queryString += queryParamStr('range[end]', dateEnd);
    }
    let fullUrl = url + queryString;
    logMessage('getResearchList fullUrl', fullUrl);
    let result = await handleRequestGet(fullUrl, {});

    return parseResult(result) || null;
};

// Always called as public: credentials 'omit' drops the HttpOnly "authorization" cookie,
// which otherwise makes the server encrypt with the token key after logout/kick.
export const getBroadcastLanding = async () => {
    let url = Config.baseURL + '/broadcast/landing';
    let { sharedKey, publicKey } = generateEcdhKeys();
    let result = null;
    try {
        let response = await fetch(url, {
            method: 'GET',
            credentials: 'omit',
            headers: {
                'Content-Type': 'application/octet-stream',
                'Ecdh-Public-Key': publicKey
            }
        });
        if (response.ok) {
            result = gcmDecrypt(await response.text(), sharedKey);
        }
    } catch (error) {
        logMessage(error);
    }
    logMessage({ getBroadcastLanding: result });
    return parseResult(result)?.announcements || [];
};

export const getAnnoucementList = async ({
    size = 10,
    page = 1,
    type = null,
    dateStart = null,
    dateEnd = null,
    term = null
}) => {
    let url = '/broadcast/announcement?';

    let queryString = '';
    queryString += queryParamStr('size', size, true);
    queryString += queryParamStr('page', page);
    queryString += queryParamStr('type', type);
    queryString += queryParamStr('term', term);
    if (dateStart && dateEnd) {
        queryString += queryParamStr('range[start]', dateStart);
        queryString += queryParamStr('range[end]', dateEnd);
    }

    let fullUrl = url + queryString;
    logMessage('fullUrl', fullUrl);
    let result = await handleRequestGet(fullUrl, {});
    logMessage('result', result);
    return parseResult(result) || null;
};
